import { Address4, Address6 } from "ip-address";

export function validateHasValue(v: string) {
	if (!!v && v.trim() !== "") {
		return true;
	}
	return false;
}

export function validateAlphaNumeric(v: string) {
	if (v.match(/^[a-zA-Z0-9]+$/)) {
		return true;
	}
	return false;
}

function isPrivateIP(ip: string) {
	// Check for IPv4
	if (ip.includes(".")) {
		const addr = new Address4(ip);
		if (addr.isInSubnet(new Address4("10.0.0.0/8"))) {
			return true;
		}
		if (addr.isInSubnet(new Address4("172.16.0.0/12"))) {
			return true;
		}
		if (addr.isInSubnet(new Address4("192.168.0.0/16"))) {
			return true;
		}
		if (addr.isInSubnet(new Address4("127.0.0.0/8"))) {
			return true;
		}
		if (addr.isInSubnet(new Address4("169.254.0.0/16"))) {
			return true;
		}

		return false;
	}

	// Check for IPv6
	if (ip.includes(":")) {
		const addr = new Address6(ip);

		if (addr.isInSubnet(new Address6("fc00::/7"))) {
			return true;
		}
		if (addr.isInSubnet(new Address6("fe80::/10"))) {
			return true;
		}
		if (addr.isInSubnet(new Address6("::1/128"))) {
			return true;
		}

		return false;
	}

	return false;
}

export function validateIPAddress(v: string) {
	if ((Address4.isValid(v) || Address6.isValid(v)) && !isPrivateIP(v)) {
		return true;
	}
	return false;
}
